import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f1df068"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pealkiri text-uppercase text-no-wrap" }
const _hoisted_2 = {
  key: 0,
  class: "text-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_timeline_item = _resolveComponent("v-timeline-item")!
  const _component_v_timeline = _resolveComponent("v-timeline")!
  const _component_v_card = _resolveComponent("v-card")!

  return ((_ctx.teavitused && _ctx.teavitused.length > 0) || _ctx.isLoading)
    ? (_openBlock(), _createBlock(_component_v_card, {
        key: 0,
        class: "pa-2"
      }, {
        default: _withCtx(() => [
          _createElementVNode("h3", _hoisted_1, [
            _createVNode(_component_v_icon, {
              icon: "mdi-alert-box",
              size: "48"
            }),
            _createTextVNode(" Tähelepanu ")
          ]),
          (_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_component_v_progress_circular, { indeterminate: "" })
              ]))
            : _createCommentVNode("", true),
          (!_ctx.isLoading)
            ? (_openBlock(), _createBlock(_component_v_timeline, {
                key: 1,
                density: "compact",
                class: "ml-2",
                "truncate-line": "end",
                side: "end",
                align: "start"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teavitused, (teavitus, index) => {
                    return (_openBlock(), _createBlock(_component_v_timeline_item, {
                      "dot-color": "var(--varv-lisa-1)",
                      key: index,
                      size: "small"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", null, _toDisplayString(teavitus), 1)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}